import React from 'react';

const MyComputer = () => {
  const filesOnComputer = [
    { name: 'Shared Documents', icon: '/documents.ico' },
    { name: "User's Documents", icon: '/documents.ico' }
  ];

  const otherPlaces = [
    { name: 'My Network Places', icon: '/network-places.ico' },
    { name: 'My Documents', icon: '/sidebar-doc.ico' },
    { name: 'Shared Documents', icon: '/my-doc-sidebar.ico' },
    { name: 'Control Panel', icon: '/control-panel.ico' }
  ];

  const drives = [
    { name: 'Local Disk (C:)', sub: 'Hard Disk (75 GB)', icon: '/hdd.ico' },
    { name: 'CD Drive (D:)', sub: 'DVD Drive', icon: '/cd-drives.ico' }
  ];

  return (
    <div className="h-full w-full text-[11px] text-[#222]" style={{ fontFamily: 'Tahoma, sans-serif' }}>

      {/* Content */}
      <div className="flex h-full min-w-0">
        {/* Left Sidebar */}
        <aside className="w-[240px] flex-shrink-0 text-white p-3 space-y-3 bg-gradient-to-b from-[#6d93ff] via-[#5f85f2] to-[#3f5fde] border border-[#6b89f7]">
          {/* Section: System Tasks */}
          <div className="rounded-md overflow-hidden shadow-[inset_1px_1px_0_rgba(255,255,255,0.4)] border border-[#90a9ff]/60">
            <div className="flex items-center justify-between px-3 py-2 bg-[#3366cc] text-white">
              <span className="font-bold">System Tasks</span>
              
            </div>
            <div className="px-3 py-2 bg-gradient-to-b from-white/35 to-white/15 text-white">
              <ul className="space-y-1">
                <li
                  role="button"
                  tabIndex={0}
                  className="flex items-center gap-2 px-2 py-[6px] rounded hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
                >
                  <img src="/sys-info.ico" alt="" className="w-4 h-4" style={{ imageRendering: 'pixelated' }} />
                  <span className="drop-shadow-[0_1px_0_rgba(0,0,0,0.3)]">View system information</span>
                </li>
                <li
                  role="button"
                  tabIndex={0}
                  className="flex items-center gap-2 px-2 py-[6px] rounded hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
                >
                  <img src="/add or remove.ico" alt="" className="w-4 h-4" style={{ imageRendering: 'pixelated' }} />
                  <span className="drop-shadow-[0_1px_0_rgba(0,0,0,0.3)]">Add or remove programs</span>
                </li>
                <li
                  role="button"
                  tabIndex={0}
                  className="flex items-center gap-2 px-2 py-[6px] rounded hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
                >
                  <img src="/control-panel.ico" alt="" className="w-4 h-4" style={{ imageRendering: 'pixelated' }} />
                  <span className="drop-shadow-[0_1px_0_rgba(0,0,0,0.3)]">Change a setting</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Section: Other Places */}
          <div className="rounded-md overflow-hidden shadow-[inset_1px_1px_0_rgba(255,255,255,0.4)] border border-[#90a9ff]/60">
            <div className="flex items-center justify-between px-3 py-2 bg-[#3366cc] text-white">
              <span className="font-bold">Other Places</span>
             
            </div>
            <div className="px-3 py-2 bg-gradient-to-b from-white/35 to-white/15 text-white">
              <ul className="space-y-1">
                {otherPlaces.map((p) => (
                  <li
                    key={p.name}
                    role="button"
                    tabIndex={0}
                    className="flex items-center gap-2 px-2 py-[6px] rounded hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
                  >
                    <img src={p.icon} alt="" className="w-4 h-4" style={{ imageRendering: 'pixelated' }} />
                    <span className="underline decoration-white/40 hover:decoration-white drop-shadow-[0_1px_0_rgba(0,0,0,0.3)]">{p.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

         
        </aside>

        {/* Right Pane */}
        <main className="flex-1 bg-white p-4 min-w-0 overflow-visible">
          {/* Files Stored On This Computer */}
          <section className="mb-4">
            <h4 className="text-[#385c9e] font-bold">Files Stored On This Computer</h4>
            <div className="xp-separator my-2 w-[25vw]" />
            <div className="flex items-center gap-8 flex-wrap">
              {filesOnComputer.map((f) => (
                <div key={f.name} className="flex items-center gap-3 cursor-pointer rounded px-1 py-1">
                  <img src={f.icon} alt="" className="w-10 h-10" style={{ imageRendering: 'pixelated' }} />
                  <div className="font-bold text-[12px]">{f.name}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Hard Disk Drives */}
          <section className="mb-4">
            <h4 className="text-[#385c9e] font-bold">Hard Disk Drives</h4>
            <div className="xp-separator my-2 w-[25vw]" />
            <div className="divide-y divide-[#d7d7d7] w-full">
              {drives.slice(0,1).map((d) => (
                <div key={d.name} className="w-full px-1 py-2">
                  <div className="inline-flex items-center gap-3 px-2 py-1 rounded cursor-pointer hover:bg-[#f7fbff]">
                    <img src={d.icon} alt="" className="w-8 h-8" style={{ imageRendering: 'pixelated' }} />
                    <div>
                      <div className="font-bold">{d.name}</div>
                      <div className="text-[#666] text-[10px]">{d.sub}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* Devices with Removable Storage */}
          <section className="mb-4">
            <h4 className="text-[#385c9e] font-bold">Devices with Removable Storage</h4>
            <div className="xp-separator my-2 w-[25vw]" />
            <div className="divide-y divide-[#d7d7d7] w-full">
              {drives.slice(1).map((d) => (
                <div key={d.name} className="w-full px-1 py-2">
                  <div className="inline-flex items-center gap-3 px-2 py-1 rounded cursor-pointer hover:bg-[#f7fbff]">
                    <img src={d.icon} alt="" className="w-8 h-8" style={{ imageRendering: 'pixelated' }} />
                    <div>
                      <div className="font-bold">{d.name}</div>
                      <div className="text-[#666] text-[10px]">{d.sub}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

        </main>
      </div>
    </div>
  );
};

export default MyComputer;
